// CustomShopGalleriesServiceProvider.tsx
import { getAll, getOne } from '../services/CRUDServiceProvider';
import { GalleryImage } from '../types/galleryImage';
import { PaginatedResponse } from '../types/pagination';
import { Translated } from '../types/translated';
import { PaginationRequest } from '../types/pagination';

let url_path = 'custom-shop-galleries';

export interface CustomShopGallery {
    title: Translated;
    description: Translated;
    slug: string;
    status: string;
    custom_shop_gallery_images?: GalleryImage[];
};

export const getAllCustomShopGalleries = async (pagination: PaginationRequest, image_size: string | undefined): Promise<PaginatedResponse<CustomShopGallery>> => {
    //console.log(token);
    console.log(url_path);
    try {
        const response = await getAll<any>(url_path, pagination, image_size);
        return response.data;
    } catch (error) {
        throw error;
    }
};

export const getCustomShopGallery = async (slug: string, image_size: string | undefined): Promise<CustomShopGallery> => {
    //console.log(token);
    console.log(url_path);
    try {
        const response = await getOne<any>(url_path, slug, image_size, undefined);
        return response.data;
    } catch (error) {
        throw error;
    }
};
